var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckdecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26688 31.4076C-6.81026 -3.48833 33.1222 4.36019 33.1222 4.36019C33.1222 4.36019 -19.1991 -13.8104 9.26688 31.4076Z",
    fill: "#D68331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckdecoration);
export default __webpack_public_path__ + "static/media/checkdecoration.a2e36ff2f363ebc1a85a21e8724d1fe7.svg";
export { ForwardRef as ReactComponent };